import React from 'react';
import styled from 'styled-components';
import { Edit } from '@material-ui/icons';
import { Button } from '@avangard/ui/core';
import { red, white } from '@avangard/ui/colors';
import { useEvent } from '@avangard/utils/hooks';

import type { SoaDocumentFileEntity } from '@modules/students/entities';

type SoaDocumentChooseProps = {
    documentFile: SoaDocumentFileEntity;
    onOpenChooseModal: () => void;
};

const editIcon = <Edit style={{ fontSize: 16 }} />;

const SoaDocumentChoose = (props: SoaDocumentChooseProps) => {
    const { documentFile, onOpenChooseModal } = props;

    const handleOpenChooseModal = useEvent(onOpenChooseModal);

    const renderChooseTrigger = React.useMemo(() => {
        if (documentFile.documentRef) {
            return (
                <Chosen onClick={handleOpenChooseModal}>
                    <p>{documentFile.documentRefChosenTitle}</p>
                    <span>{editIcon}</span>
                </Chosen>
            );
        }

        if (documentFile.file.exists()) {
            return (
                <Chosen onClick={handleOpenChooseModal}>
                    <p>{documentFile.file.name}</p>
                    <span>{editIcon}</span>
                </Chosen>
            );
        }

        return (
            <Button variant='outlined' onClick={handleOpenChooseModal}>
                Выбрать
            </Button>
        );
    }, [documentFile, handleOpenChooseModal]);

    return <Root>{renderChooseTrigger}</Root>;
};

const Root = styled.div``;

const Chosen = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 16px;

    background-color: ${white[50]};
    border-radius: 4px;

    cursor: pointer;

    p {
        color: ${red[100]};
        font-size: 1.4rem;
    }

    span {
        display: inline-flex;
        align-items: center;
    }
`;

export { SoaDocumentChoose };
